import { render, staticRenderFns } from "./ParametrosPadraoFormulario.vue?vue&type=template&id=14480cb2&lang=pug"
import script from "./ParametrosPadraoFormulario.vue?vue&type=script&lang=js"
export * from "./ParametrosPadraoFormulario.vue?vue&type=script&lang=js"
import style0 from "./ParametrosPadraoFormulario.vue?vue&type=style&index=0&id=14480cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports